import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

const influencerItemSelector = item => item;

const selectedProductsFiltersSelector = createSelector(
  influencerItemSelector,
  item => (!isEmpty(item) && item.page.deal.selectedProductsFilters
    ? item.page.deal.selectedProductsFilters
    : []),
);

export const dealSelectedProductsFilterSelector = createSelector(
  selectedProductsFiltersSelector,
  selectedProductsFilters => (selectedProductsFilters),
);

export default {
  dealSelectedProductsFilterSelector,
};
